import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDnFJ0mT3qNBaIZt5EbQyEVEyR2P0ELCCY",
  authDomain: "com.falcon.q2hadmin",
  projectId: "haribhavanam-335c9",
  storageBucket: "com.falcon.q2hadmin",
  messagingSenderId: "168451462501",
  appId: "1:168451462501:android:590fe715ce23a784dc3d8c",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
